import type { FC } from 'react';
import type { FaqDto } from '@/queries/system-pages';
import { useTranslations } from 'next-intl';
import { BaseAccordion, BaseAccordionContent, BaseAccordionItem, BaseAccordionTrigger } from './base-accordion';

interface FaqAccordionSectionProps {
  className?: string;
  faqsList?: FaqDto[];
}

export const FaqAccordionSection: FC<FaqAccordionSectionProps> = ({ className, faqsList }) => {
  const t = useTranslations('common');

  if (!faqsList || faqsList.length === 0) {
    return null;
  }

  return (
    <section className={className}>
      <h3 className="mb-3.75 md:mb-4.75 text-xl leading-[1.4] font-medium text-light">{t('faq')}</h3>

      {
        faqsList.map((item, index) => (
          <BaseAccordion type="single" collapsible className="w-full" key={index}>
            <BaseAccordionItem value={`item-${index + 1}`} className="box-border border-t border-light/10">

              <BaseAccordionTrigger className="text-primary-3 py-2.5 md:py-3 -mt-px text-lg tracking-normal pr-1.5 leading-7 md:pr-3">
                {item.question}
              </BaseAccordionTrigger>
              <BaseAccordionContent className="text-light text-base leading-6 mb-6.5 md:mt-3 mt-4.5 md:mb-4.5">
                {item.answer}
              </BaseAccordionContent>
            </BaseAccordionItem>
          </BaseAccordion>
        ))
      }
    </section>
  );
};
